module.exports = "/images/job-loss-background.png?727b6d2bb20ceb6b6494be29dc81767a";